import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import PageHeader from '@common/PageHeader'
import { RouterView } from '@merchant-backend/common-components'
import 'antd4/lib/grid/style/index.css'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import UploadImage from '../../common/UploadImage'
import UploadVideo from '../../common/UploadVideo'
import { formItemLayout } from '../../constants'
import styles from './style.module.less'

const FormItem = Form.Item

@inject('store')
@observer
class InstanceAuth extends Component {
  render() {
    const { store, form } = this.props
    const { form_init } = store
    const { getFieldDecorator } = form
    const form_default = toJS(form_init)

    return (
      <RouterView
        domId="main-content3"
        title={
          <div>
            实例认证（选填）
            {form_default.certified == 1 && (
              <span className={styles.passLabel}>认证通过</span>
            )}
          </div>
        }
        bodyStyle={{ padding: '24px' }}
        titleStyle={{ height: 48, padding: '0 24px' }}
      >
        <>
          <PageHeader
            style={{ color: '#333', marginBottom: 40 }}
            title="通过实例认证，有助于案例真实性和原创性保护。为保护商家利益，平台会严格审核认证资料，若认证资料涉嫌造假，将取消实例认证并受到惩罚。举证资料只用于平台审核，不会在婚礼纪 app 上展示。"
          />
          <FormItem
            colon={false}
            style={{ marginBottom: 32 }}
            label="原片/视频"
            {...formItemLayout}
          >
            {getFieldDecorator('verify_origin', {
              initialValue: form_default.verify_origin,
              rules: [
                {
                  required: false
                  // message: '请上传婚礼现场原片或视频'
                }
              ]
            })(<UploadVideo />)}
          </FormItem>
          <FormItem
            style={{ marginBottom: 0 }}
            colon={false}
            label="其他举证"
            {...formItemLayout}
          >
            {getFieldDecorator('verify_others', {
              initialValue: form_default.verify_others,
              rules: [
                {
                  required: false
                  // message: '请上传举证图片'
                }
              ]
            })(<UploadImage />)}
          </FormItem>
        </>
      </RouterView>
    )
  }
}

export default InstanceAuth
